import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { TextLinkButtonColor } from 'framework/components/buttons/TextLinkButtonColor';
import { DownloadMultipleIcon } from 'framework/components/icons/DownloadMultipleIcon';
import { useAnchorElement } from 'framework/hooks/useAnchorElement';
import { ExportFormat } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo } from 'react';
import { ExportMenu } from './ExportMenu';

interface IProps {
	filteredCount: number;
	unfilteredCount: number;
	onExportClick: (applyFilter: boolean, format: ExportFormat) => void;
	children?: any;
	anchor?: [null | HTMLElement, (event: React.MouseEvent<HTMLElement>) => void, VoidFunction, undefined];
	style?: React.CSSProperties;
	color?: TextLinkButtonColor;
	hoverColor?: TextLinkButtonColor;
}

export const TextLinkExportButtonAndMenu = ({ filteredCount, unfilteredCount, onExportClick, children, anchor, ...rest }: IProps) => {
	const strings = useLocalization();
	const localAnchor = useAnchorElement();
	const [menuAnchor, openMenu, closeMenu] = useMemo(() => anchor ?? localAnchor, [anchor, localAnchor]);

	return (
		<>
			<TextLinkButton
				startIcon={<DownloadMultipleIcon />}
				onClick={openMenu}
				{...rest}>
				{strings.exportVerb}
			</TextLinkButton>
			<ExportMenu
				filteredCount={filteredCount}
				unfilteredCount={unfilteredCount}
				menuAnchor={menuAnchor}
				closeMenu={closeMenu}
				onExportClick={onExportClick}>
				{children}
			</ExportMenu>
		</>
	);
};
